(() => {
  const initMenu = (menu) => {
    const tabs = menu.querySelectorAll('[data-product-info-tab]');
    const panels = menu.querySelectorAll('[data-product-info-panel]');

    if (!tabs.length || !panels.length) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.productInfoTab;

        tabs.forEach((button) => {
          const isActive = button.dataset.productInfoTab === target;
          button.classList.toggle('is-active', isActive);
          button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach((panel) => {
          panel.hidden = panel.dataset.productInfoPanel !== target;
        });
      });
    });
  };

  const boot = () => {
    document.querySelectorAll('[data-product-info-menu]').forEach(initMenu);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
